import React from 'react';
import { Form } from 'react-final-form';
import PropTypes from 'prop-types';

import { PageErrorComponent } from '../../commons/PageErrorComponent';
import GenericFormPrivacyPolicySection from '../../commons/privacy-policy/GenericFormPrivacyPolicySection';
import { getRetainDeleteOptions } from '../RetentionConstants';
import GenericRadioGroupField from '../../commons/form-fields/GenericRadioGroupField';

export const RetentionForm = (props) => {
    const _renderSubmitButtonAndErrors = (submitFailed, errors) => (
        <div className="text-center mt-8 mb-4">
            {submitFailed && <PageErrorComponent error={errors} />}
            <button
                className="bg-customGreen text-white font-bold py-2 px-8 rounded"
                type="submit"
            >
                Submit
            </button>
        </div>
    );

    const retainDeleteOptions = getRetainDeleteOptions(props.consultantCountry);

    return (
        <Form
            keepDirtyOnReinitialize
            onSubmit={props.onSubmit}
            render={({ handleSubmit, errors, submitFailed }) => (
                <>
                    <form onSubmit={handleSubmit} autoComplete="off">
                        <GenericRadioGroupField
                            name="consentResponse"
                            required
                            size="small"
                            options={retainDeleteOptions}
                        />
                        <br />
                        <GenericFormPrivacyPolicySection
                            country={props.consultantCountry}
                            fieldClassName="flex"
                        />
                        {_renderSubmitButtonAndErrors(submitFailed, errors)}
                    </form>
                </>
            )}
        />
    );
};

RetentionForm.propTypes = {
    onSubmit: PropTypes.func,
    consultantCountry: PropTypes.string,
};
